import { render, staticRenderFns } from "./BroadcastCrtNew.vue?vue&type=template&id=1f0c148e&scoped=true&"
import script from "./BroadcastCrtNew.vue?vue&type=script&lang=js&"
export * from "./BroadcastCrtNew.vue?vue&type=script&lang=js&"
import style0 from "./BroadcastCrtNew.vue?vue&type=style&index=0&id=1f0c148e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f0c148e",
  null
  
)

export default component.exports